import DashboardService from 'src/services/dashboard'

export default {
  getDashboards () {
    const promise = DashboardService.getDashboards()

    promise.then(response => {
      this.dashboards = response.data
    })

    return promise
  },
  newDashboard (payload) {
    const promise = DashboardService.newDashboard(payload)

    promise.then(response => {
      const dashboards = this.dashboards
      dashboards.push(response.data)
      this.dashboards = dashboards
    })

    return promise
  },
  deleteDashboard (id) {
    const promise = DashboardService.deleteDashboard(id)

    promise.then(() => {
      const dashboards = this.dashboards
      const filtered = dashboards.filter(d => d.id !== id)
      this.dashboards = filtered
    })

    return promise
  },
  favorite (id) {
    const promise = DashboardService.favoriteDashboard(id)

    promise.then(() => {
      const dashboards = this.dashboards.map(dash => {
        dash.default = dash.id === id
        return dash
      })
      this.dashboards = dashboards
    })

    return promise
  },
  updateDashboard (payload) {
    const promise = DashboardService.updateDashboard(payload)

    promise.then(() => {
      const dashboards = this.dashboards.map(dash => {
        dash.name = dash.id === payload.id ? payload.name : dash.name
        return dash
      })
      this.dashboards = dashboards
    })

    return promise
  },
  duplicateDashboard (payload) {
    const promise = DashboardService.duplicateDashboard(payload)

    promise.then(response => {
      const dashboards = this.dashboards
      dashboards.push(response.data)
      this.dashboards = dashboards
    })

    return promise
  },
  setSelectedDashboard (selectedDashboard) {
    this.selectedDashboard = selectedDashboard
  }
}
